import React, { useEffect, useState } from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { listVerticals, resolveFileUrl } from '../services/api';

const Services = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listVerticals()
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="bg-[#e2ede6] pb-20 lg:pb-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="border border-[#0f5c3d]/30 rounded-2xl p-6 lg:p-12 bg-[#e2ede6]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            {/* Left */}
            <div className="lg:sticky lg:top-28">
              <span className="text-xs font-semibold tracking-[0.25em] text-[#0f5c3d] uppercase">
                Our Business Verticals
              </span>
              <h2
                className="mt-4 text-4xl lg:text-5xl text-[#0b1a2e] leading-[1.05]"
                style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
              >
                A global conglomerate across finance, technology, energy and resources.
              </h2>
              <p className="mt-6 text-[#0b1a2e]/70 leading-relaxed max-w-md">
                Emerald operates across eleven interconnected verticals — each led by senior
                specialists, backed by international partnerships and built for a fast-changing
                global economy.
              </p>
              <Link
                to="/verticals"
                className="mt-8 inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-[#0b1a2e] text-white hover:bg-[#0f5c3d] transition-colors"
              >
                <span className="text-sm font-medium tracking-wide">Explore all verticals</span>
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            {/* Right - Vertical cards from CMS (scrollable) */}
            <div className="relative">
              {loading ? (
                <div className="bg-white/60 rounded-2xl p-10 text-center text-[#0b1a2e]/60">
                  <Loader2 className="w-5 h-5 animate-spin inline mr-2" /> Loading verticals…
                </div>
              ) : items.length === 0 ? (
                <div className="bg-white/60 rounded-2xl p-10 text-center text-[#0b1a2e]/60">
                  Verticals coming soon.
                </div>
              ) : (
                <>
                  <div className="max-h-[640px] overflow-y-auto pr-2 space-y-6 custom-scrollbar">
                    {items.map((s) => (
                      <Link
                        key={s.id}
                        to={`/verticals/${s.slug}`}
                        className="group relative block rounded-2xl overflow-hidden aspect-[16/7] shadow-lg hover:shadow-2xl transition-all duration-500"
                      >
                        <img
                          src={resolveFileUrl(s.image_url)}
                          alt={s.title}
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-tr from-[#0b1a2e]/85 via-[#0b1a2e]/55 to-[#0f5c3d]/40" />
                        <div className="relative h-full flex flex-col justify-center items-center text-center px-6 text-white">
                          {s.eyebrow && (
                            <span className="text-[10px] font-semibold tracking-[0.3em] uppercase text-emerald-200 mb-2">
                              {s.eyebrow}
                            </span>
                          )}
                          <h3
                            className="text-2xl lg:text-3xl leading-tight"
                            style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                          >
                            {s.title}
                          </h3>
                          <div className="mt-3 inline-flex items-center gap-2 text-sm font-medium opacity-90 group-hover:gap-3 transition-all">
                            Learn More <ArrowRight className="w-4 h-4" />
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                  <div className="mt-3 text-[11px] text-[#0b1a2e]/50 text-center">
                    Scroll to see all {items.length} verticals
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
